import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbsComponent } from 'components/breadcrumbs/breadcrumbs.component';
import { TableComponent } from 'components/table/table.component';
import { API_BACKOFFICE_USER, ApiService } from 'services/api.service';
import { ActivationStatus } from 'types/user.interface';
import { Breadcrumb } from 'types/breadcrumb.interface';
import { FilterType, TableColumn } from 'types/table-column.interface';

@Component({
  selector: 'app-backoffice-user-list-page',
  standalone: true,
  imports: [TableComponent, TranslateModule, NgClass, BreadcrumbsComponent],
  templateUrl: './backoffice-user-list-page.component.html',
  styleUrl: './backoffice-user-list-page.component.scss'
})
export class BackofficeUserListPageComponent {
  public readonly apiPath = API_BACKOFFICE_USER;
  isExcelDownloading: boolean = false;

  tableColumns: TableColumn[] = [
    {
      name: 'pages.user.tableColumns.activationStatus',
      key: 'activationStatus',
      sortKey: 'activationStatus',
      styleClass: 'status-column',
      filter: FilterType.MultiSelect,
      multiselectFilterName: 'activationStatuses',
      filterOptions: Object.values(ActivationStatus),
      sortEnabled: true,
      valueTranslate: 'pages.user.activationStatus.'
    },
    {
      name: 'pages.user.tableColumns.absence',
      key: 'activeAbsence',
      sortKey: 'activeAbsence',
      sortEnabled: true,
      customLogic: 'activeAbsence',
      filter: FilterType.Date
    },
    {
      name: 'pages.user.tableColumns.fullName',
      key: 'fullName',
      sortKey: 'fullName',
      sortEnabled: true,
      filter: FilterType.Search
    },
    {
      name: 'pages.user.tableColumns.roleNames',
      sortKey: 'roleNames',
      key: 'roleNames',
      sortEnabled: true,
      filter: FilterType.Search
    },
    {
      name: 'pages.user.tableColumns.structuralUnitNames',
      key: 'structuralUnitNames',
      sortKey: 'structuralUnitNames',
      styleClass: 'structural-unit-names',
      sortEnabled: true,
      filter: FilterType.Search
    }
  ];

  constructor(private apiService: ApiService) {}

  breadcrumbs: Breadcrumb[] = [
    {
      title: 'components.breadcrumbs.admin',
      url: ''
    },
    {
      title: 'components.breadcrumbs.users',
      url: '/lietotaji'
    }
  ];

  getExcelFile() {
    if (!this.isExcelDownloading) {
      this.isExcelDownloading = true;
      this.apiService.getUserExcel().subscribe(
        (data: any) => {
          if (data) {
            this.saveExcelFile(data);
            this.isExcelDownloading = false;
          }
        },
        (error: any) => {
          console.error(error);
        }
      );
    }
  }

  saveExcelFile(blob: Blob): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'lietotaji.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
